import { AuthToken } from '../../../domain/auth/model/auth-token';

export namespace AuthActions {
  const prefix: string = '[Auth]';

  export class Login {
    static readonly type = `${prefix} Log in`;

    constructor(
      public username: string,
      public password: string
    ) {}
  }

  export class LoginWithGoogle {
    static readonly type = `${prefix} Log in with google`;

    constructor() {}
  }

  export class LoginWithFacebook {
    static readonly type = `${prefix} Log in with facebook`;

    constructor() {}
  }

  export class ConfirmSocialLogin {
    static readonly type = `${prefix} Confirm social login`;

    constructor() {}
  }

  export class SetPassword {
    static readonly type = `${prefix} Set password`;

    constructor(public password: string) {}
  }

  export class ResetPassword {
    static readonly type = `${prefix} Reset password`;

    constructor(public username: string) {}
  }

  export class ConfirmResetPassword {
    static readonly type = `${prefix} Confirm reset password`;

    constructor(
      public username: string,
      public code: string,
      public password: string
    ) {}
  }

  export class ChangePassword {
    static readonly type = `${prefix} Change password`;

    constructor(
      public currentPassword: string,
      public password: string
    ) {}
  }

  export class GetCurrentLogged {
    static readonly type = `${prefix} Get current logged user`;

    constructor() {}
  }

  export class SaveToken {
    static readonly type = `${prefix} Update token`;

    constructor(public token: AuthToken) {}
  }

  export class RefreshToken {
    static readonly type = `${prefix} Refresh token`;

    constructor() {}
  }

  export class Logout {
    static readonly type = `${prefix} Log out`;

    constructor() {}
  }
}
